import React from "react";
import PropertyItem from "./PropertyItem";
const PropertyGrid = ({ properties }) => {
  return (
    <div className="grid gap-4 py-[20px] md:grid-cols-2 lg:grid-cols-2 xl:grid-cols-3">
      {properties?.map((property, index) => (
        <PropertyItem key={index} property={property} />
      ))}
    </div>
  );
};

export default PropertyGrid;
